import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faPlus } from '@fortawesome/free-solid-svg-icons'
import { useTheme } from '../../../../context/ThemeProvider'
import { getSaiTerminology } from '../../../../config/terminology'

const PolicyBenefits = ({ policyData, onUpgrade, showSectionHeading = false }) => {
  const theme = useTheme()
  const terms = getSaiTerminology(policyData)
  const isAIS = policyData?.department === 'AIS'
  const isMutual = policyData?.department === 'Mutual' || policyData?.department === 'GBS'
  if (!isMutual && theme.name === 'Cover and Care') return null

  return (
    <>
      {showSectionHeading && (
        <div className="font-semibold text-xl pt-4">What you can access as part of your {terms.policy.singularLower}</div>
      )}
      <div className={showSectionHeading ? 'bg-white rounded-lg shadow-md p-4 w-full' : undefined}>
        {policyData?.department === "Mutual" || policyData?.department === "GBS" ? (
          <div className="grid md:grid-cols-3 gap-6 text-sm">
            <div>
              <p className="font-semibold mb-2">Included in your {policyData?.product} {terms.policy.singularTitle}:</p>
              <ul className="space-y-1 text-gray-800">
                <li><FontAwesomeIcon icon={faCheck} className="text-[#8acb94] mr-2" /> Jury service</li>
                <li><FontAwesomeIcon icon={faCheck} className="text-[#8acb94] mr-2" /> Sickness</li>
                <li><FontAwesomeIcon icon={faCheck} className="text-[#8acb94] mr-2" /> Suspension</li>
                <li><FontAwesomeIcon icon={faCheck} className="text-[#8acb94] mr-2" /> Bereavement leave</li>
                <li><FontAwesomeIcon icon={faCheck} className="text-[#8acb94] mr-2" /> Stress-related absences (where purchased)</li>
                <li><FontAwesomeIcon icon={faCheck} className="text-[#8acb94] mr-2" /> Compassionate leave (where purchased)</li>
              </ul>
            </div>
        
            <div>
              <ul className="mt-[32px] space-y-1 text-gray-800">
                <li><FontAwesomeIcon icon={faCheck} className="text-[#8acb94] mr-2" /> Stranded staff</li>
                <li><FontAwesomeIcon icon={faCheck} className="text-[#8acb94] mr-2" /> Accidents in or out of work</li>
                <li><FontAwesomeIcon icon={faCheck} className="text-[#8acb94] mr-2" /> Phased return to work</li>
                <li><FontAwesomeIcon icon={faCheck} className="text-[#8acb94] mr-2" /> Adoption leave (where purchased)</li>
                <li><FontAwesomeIcon icon={faCheck} className="text-[#8acb94] mr-2" /> Maternity leave (where purchased)</li>
                <li><FontAwesomeIcon icon={faCheck} className="text-[#8acb94] mr-2" /> Paternity leave (where purchased)</li>
              </ul>
            </div>
        
            
            {policyData?.product?.toLowerCase().includes("enhanced") ? (
              <div>
                <ul className="mt-[32px] space-y-1 text-gray-800">
                  <li><FontAwesomeIcon icon={faCheck} className="text-[#8acb94] mr-2" /> Pre-existing conditions</li>
                  <li><FontAwesomeIcon icon={faCheck} className="text-[#8acb94] mr-2" /> Pre-planned operations</li>
                </ul>
              </div>
            ) : (
              <div>
                <p className="font-semibold mb-2">Upgrade to Enhanced Protection Option for:</p>
                <p className="text-sm"> <FontAwesomeIcon icon={faPlus} className="text-[#8acb94] mr-2" />Pre-existing conditions  </p>
                <p className="text-sm"> <FontAwesomeIcon icon={faPlus} className="text-[#8acb94] mr-2" />Pre-planned surgery </p>
                <p onClick={() => onUpgrade()} className="text-[#8acb94] underline cursor-pointer mt-4">Contact us for more details</p>
              </div>
            )}
          </div>
        ) : theme.name !== "Cover and Care" && (
          <div className="text-sm">
            <p className="font-semibold mb-2 text-[#009CDE]">Included in your Policy:</p>
            <div className="grid md:grid-cols-3 gap-6">
              <div>
                <ul className="list-none space-y-2">
                  <li><FontAwesomeIcon icon={faCheck} className="text-[#009CDE] mr-2" />Sickness or injury absences</li>
                  <li><FontAwesomeIcon icon={faCheck} className="text-[#009CDE] mr-2" />Accidents in or out of work</li>
                  <li><FontAwesomeIcon icon={faCheck} className="text-[#009CDE] mr-2" />Phased returns to work</li>
                  <li><FontAwesomeIcon icon={faCheck} className="text-[#009CDE] mr-2" />Bereavement</li>
                  {!isAIS && (<li><FontAwesomeIcon icon={faCheck} className="text-[#009CDE] mr-2" />Compassionate leave</li>)}
                </ul>
              </div>
        
              <ul className="list-none space-y-2">
                <li><FontAwesomeIcon icon={faCheck} className="text-[#009CDE] mr-2" />Jury Service</li>
                <li><FontAwesomeIcon icon={faCheck} className="text-[#009CDE] mr-2" />Dedicated account manager</li>
                {!isAIS && (<li><FontAwesomeIcon icon={faCheck} className="text-[#009CDE] mr-2" />Suspension</li>)}
                {!isAIS && (<li><FontAwesomeIcon icon={faCheck} className="text-[#009CDE] mr-2" />Stranded staff abroad</li>)}
                {!isAIS && (<li><FontAwesomeIcon icon={faCheck} className="text-[#009CDE] mr-2" />Ofsted Inspection engagement duties</li>)}
        
              </ul>
              <ul className="list-none space-y-2">
                {!isAIS && (<li><FontAwesomeIcon icon={faCheck} className="text-[#009CDE] mr-2" />Trade union/association duties</li>)}
                <li><FontAwesomeIcon icon={faCheck} className="text-[#009CDE] mr-2" />Online claims portal</li>
                <li><FontAwesomeIcon icon={faCheck} className="text-[#009CDE] mr-2" />Stress related absences (where purchased)</li>
                <li><FontAwesomeIcon icon={faCheck} className="text-[#009CDE] mr-2" />Maternity/Parental leave (where purchased)</li>
              </ul>
            </div>
        
            {policyData?.product === 'SAS Policy Plus' && (<div className='mt-4 w-full'>
              <p className="font-semibold mb-2 text-[#009CDE]">Included in Policy Plus Cover:</p>
              <ul className="list-none space-y-2">
                <li><FontAwesomeIcon icon={faCheck} className="text-[#009CDE] mr-2" />Cover for <span className='font-bold'>pre-existing conditions</span> and <span className='font-bold'>pre-planned surgery</span></li>
              </ul>
            </div>)}
        
            {!isAIS && (<div className="grid md:grid-cols-2 gap-6 mt-6 mb-6">
              
              {policyData?.product !== 'SAS Policy Plus' && (<div>
                <p className="font-semibold mb-2">Upgrade to SAS Policy Plus for:</p>
                <ul className="list-none space-y-1">
                  <li> <FontAwesomeIcon icon={faPlus} className="text-sas mr-2" />Pre-existing conditions</li>
                  <li> <FontAwesomeIcon icon={faPlus} className="text-sas mr-2" />Pre-planned surgery</li>
                </ul>
                <div onClick={() => onUpgrade()} className="text-sas cursor-pointer underline text-xs mt-2 inline-block">Contact us for more details</div>
              </div>)}
        
              
            </div>)}
          </div>
        )}
      </div>
    </>
  )
}

export default PolicyBenefits
